module.exports = __webpack_public_path__ + "use-cases-5-23d512ed289eb536c6e33e27450ae626.webp";